import type { RouteLocation } from 'vue-router';

export default defineNuxtPlugin({
    name: 'guard',
    dependsOn: ['auth', 'sitemap', 'alerts', 'i18n'],
    async setup(nuxtApp)
    {
        const { $router, $sitemap, $alert, $i18n } = useNuxtApp();
        const store = useAuthStore();
        const options = useAuthOptions();

        $router.beforeEach(async (to: RouteLocation, from: RouteLocation, next: any) =>
        {
            if (to.meta && 'auth' in to.meta && to.name != from?.name)
            {
                const auth: any = to.meta.auth;

                // Wymuszenie zmiany hasła
                if (auth !== false && store.authenticated === true && store.identity.forcePasswordChange === true && to.meta.stop !== true)
                {
                    $alert.debounceInfo($i18n.$t('[[[Twoje hasło wygasło. Zmień je na nowe.]]]'));
                    next(options.routes.changePassword);

                    return;
                }

                if (typeof (auth) === 'boolean')
                {
                    if (auth === true && store.authenticated === false)
                    {
                        next(options.routes.loginPage);

                        return;
                    }

                    if (auth === false && store.authenticated === true)
                    {
                        next(options.routes.homePage);

                        return;
                    }

                    if (store.authenticated === true)
                    {
                        // Pobranie aktualnego widoku z sitemapa
                        const node = await $sitemap.find(to);

                        // Sprawdzenie uprawnień do widoku w sitemapie
                        if (node && node.allowed == false)
                        {
                            next(options.routes.forbidden);

                            return;
                        }
                    }
                }

                if (Array.isArray(auth) && auth.length > 0)
                {
                    if (store.authenticated === false)
                    {
                        next(options.routes.loginPage);

                        return;
                    }
                }
            }

            next();
        });
    }
});
